import * as React from 'react';
import { Box, Grid, Typography, Button, List, ListItem, ListItemIcon, ListItemText } from '@mui/material';
import DownloadIcon from '@mui/icons-material/Download';
import DocumentScannerIcon from '@mui/icons-material/DocumentScanner';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { CustomSecondaryDownLoadButton } from '../../../../Global_Component/GlobalButtonComponent';

export default function AgreementsPage() {
  const agreements = [
    { name: 'Non disclosure agreement', status: 'Pending' },
    { name: 'Standard logo mark agreement', status: 'Accepted' }
  ];

  return (
    <Box sx={{ maxWidth:"100%",width:"100%", p: 3, mx: 'auto', backgroundColor: '#ffffff', borderRadius: 2, boxShadow: '0px 3px 6px rgba(0,0,0,0.1)' }}>
      <Typography variant="body1" color="textSecondary" sx={{ mb: 2 ,p:2,color:"#000000",fontWeight:"400",bgcolor:"#F9FAFC",textAlign:"center",border:"2px solid #DFE3EC",borderRadius:3}}>
        Following Agreements and NDAs are required for the certification
      </Typography>
      
      <Grid container justifyContent="space-between" alignItems="center" sx={{ mb: 2 }}>
        <Typography variant="h6">List</Typography>
        <CustomSecondaryDownLoadButton
                label={"Download All"}
               />
      </Grid>

      <List>
        {agreements.map((agreement, index) => (
          <ListItem key={index} sx={{ border: '1px solid #e0e0e0', borderRadius: 2, mb: 1, p: 2 }}>
            <ListItemIcon>
              <DocumentScannerIcon />
            </ListItemIcon>
            <ListItemText primary={agreement.name} sx={{width:"auto",width:"40%"}}/>
            <Grid container justifyContent="flex-end" alignItems="center" spacing={2}>
              <Grid item>
                <CustomSecondaryDownLoadButton
                label={"Download"}
               />
            
              </Grid>
              <Grid item>
                <Button
                  variant="contained"
                  color={agreement.status=='Pending'?"warning":"success"}
                  startIcon={agreement.status === 'Pending' ? <></> : <CheckCircleIcon />}
              
                  sx={{ textTransform: 'none',borderRadius:4 ,minWidth:"125px"}}
                >
                  {agreement.status}
                </Button>
              </Grid>
            </Grid>
          </ListItem>
        ))}
      </List>
    </Box>
  );
}